import React from 'react'
import CustomTable from '../../shared/CustomTable'
import { MdOutlineRemoveRedEye } from 'react-icons/md'
function PolicyTable () {
  const handleView = row => {
    console.log('View clicked for row:', row)
  }
  return (
    <div>
      <CustomTable
        headers={[
          'Policy number',
          'Policy Holder Name',
          'Payer',
          'TPA',
          'Effective Date',
          'End Date'
        ]}
        // rows={[{ 'Policy number': 'John Doe', Age: 28, Location: 'New York' }]}
        // actions={[
        //   {
        //     label: 'View',
        //     icon: <MdOutlineRemoveRedEye />,
        //     callback: row => handleView(row)
        //   }
        // ]}
      />
    </div>
  )
}

export default PolicyTable
